// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__vmCeD","wrapper":"Container_wrapper__VKrus","title":"Container_title__hmw1j"};